import React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ProductItemCard from "../components/ProductItemCard";
import LoadingSpinner from "../components/Common/LoadingSpinner.jsx";
import { Form, Button, Row, Col, Container, InputGroup } from "react-bootstrap";

/**
 *
 * @param {*} props.data
 * {
 *       "searchProducts": {
 *         "title": "We are your complete solution",
 *         "subTitle": "Find a vehicle you dream of",
 *         "mode": "pulledUp",
 *         "mode_comment": "pulledUp|normal|halfWide"
 *       }
 *     },
 */
const SearchProductsComplex = (props) => {
  const [prod, setProd] = useState({});
  const [searchResultsArray, setSearchResultsArray] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [view, setView] = useState(false);
  const products = useSelector((state) => state.product.products);
  const [staticProjectName, setStaticProjectName] = useState(
    window.localStorage.getItem("staticProjectName")
  );
  if (props.data) {
    var { id, mode, title, subTitle } = props.data;
  }
  console.log("staticProjectName in SearchProducts", staticProjectName);

  useEffect(() => {
    setProd(products.find((p) => p.id === id));
  }, [products.size, products, prod, id]);

  useEffect(() => {
    setView(false);
    //you can add deBouncing fnx with setTimeout() to not call api anytime user types
    const deBouncingFnx = setTimeout(() => {
      if (searchTerm?.length >= 3) {
        setSearchResultsArray([]);
        SearchLogic();
      }
    }, 2000);

    // make sure you reset timer if using de-bouncer return () => clearTimeout(deBounceFnx)
    return () => {
      clearTimeout(deBouncingFnx);
    };
  }, [searchTerm]);

  // To Be Done
  const SearchLogic = () => {
    //once term set this piece will return array of found products

    const filteredProducts = products.filter((product) => {
      return (
        product?.description
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        product?.name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
    setSearchResultsArray(filteredProducts);
    setView(true);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    // handle form data here
    const formData = new FormData(e.target);
    const complain = formData.get("complain");
    const location = formData.get("location");
    const category = formData.get("category");
    console.log({ complain, location, category });
  };

  return (
    <Container className={mode ? mode : "normal"}>
      <Form onSubmit={handleSearch}>
        <Row className="align-items-center">
          <Col md={3}>
            <Form.Group controlId="complain">
              <Form.Control
                type="text"
                placeholder="My complain is about..."
                defaultValue={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={(e) => setSearchTerm(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group controlId="location">
              <Form.Select name="location">
                <option value="">Select Location</option>
                <option value="london">London</option>
                <option value="manchester">Manchester</option>
                <option value="birmingham">Birmingham</option>
                <option value="glasgow">Glasgow</option>
                <option value="liverpool">Liverpool</option>
                <option value="bristol">Bristol</option>
                <option value="leeds">Leeds</option>
                <option value="edinburgh">Edinburgh</option>
                <option value="cardiff">Cardiff</option>
                <option value="belfast">Belfast</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group controlId="category">
              <Form.Select name="category">
                <option value="">Select Category</option>
                <option value="billing">Billing</option>
                <option value="technical">Technical</option>
                <option value="general">General</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Button type="submit" variant="primary" className="w-100">
              <span className="me-2"> Search</span>{" "}
              <i className="fa-solid fa-magnifying-glass"></i>
            </Button>
          </Col>
        </Row>
      </Form>
      {view ? (
        <div className="my-2 ">
          {searchResultsArray?.length > 0 ? (
            <p>
              Found: <b>{searchResultsArray?.length}</b> results for term{" "}
              <b>{searchTerm}</b>
            </p>
          ) : (
            <p>
              Found: <b>{searchResultsArray?.length}</b> results for term{" "}
              <b>{searchTerm}</b>
            </p>
          )}
          <div className="component  d-flex flex-column">
            {searchResultsArray?.length > 0 &&
              searchResultsArray.map((product, i) => {
                return (
                  <ProductItemCard
                    className="col-xs-12 col-lg-3 col-sm-4 single-card p-4"
                    data={product}
                    link={product.id}
                    key={i}
                  />
                );
              })}
            {searchResultsArray
              ? console.log("searchResultsArray", searchResultsArray)
              : null}
          </div>
        </div>
      ) : (
        searchTerm && (
          <div
            className=" mt-4 d-flex text-center flex-column justify-content-center align-items-center"
            style={{ width: "100%", height: "100%" }}
          >
            <div className="loaderSpin mt-2 "></div>
            <p> Searching for {searchTerm}</p>
          </div>
        )
      )}
    </Container>
  );
};

export default SearchProductsComplex;
